import gql from "graphql-tag.macro";

/*

query currentWorkflowInstance ($parentid: String!) {
  workflowinstances (meta: { parent_id: $parentid }) {
    edges {
      node {
        actions {
          edges {
            node {
              _id
              comment
              status
              customstatus
              statusChangedAt
              fulfilledAt
              rejectedAt
              cancelledAt
              kind
              name
              displayname
              displaytype
              description
              identifier
              sendNotification
              customstati
            }
          }
        }
        myactions {
          edges {
            node {
              _id
              comment
              status
              customstatus
              statusChangedAt
              fulfilledAt
              rejectedAt
              cancelledAt
              kind
              name
              displayname
              displaytype
              description
              identifier
              sendNotification
              customstati
            }
          }
        }
        log {
          data {
            index
            timestamp
            data {
              who {
                id
              }
              when
              why {
                human
                robot
              }
              what {
                path
                value
                from
              }
            }
            precedingHash
            hash
          }
        }
        currentStage {
          _id
          name
          description
          nextStageIds
          prevStageIds
          nextStages {
            _id
            name
          }
          prevStages {
            _id
            name
          }
          PlannedStart
          PlannedEnd
          ForCastedStart
          ForCastedEnd
          PlannedDuration
          defaultActionType
        }
        stages {
          _id
          name
          description
          nextStageIds
          prevStageIds
          nextStages {
            _id
            name
          }
          prevStages {
            _id
            name
          }
          PlannedStart
          PlannedEnd
          ForCastedStart
          ForCastedEnd
          PlannedDuration
          defaultActionType
        }
        currentStageStartDate
        startDate
        forcastEndDate
        plannedEndDate
        description
        name
        workflowmodelid
        etag
        _id
      }
    }
  }
}

*/

const loadCurrentWorkflowinstanceQuery = gql`
    query currentWorkflowInstance ($docid: ID!) {
        v2document(id: $docid) {
            name @client
            id
            workflowinstance {
                _id
            }
        }
    }
`;

export const loadCurrentWorkflowinstance = async ({ client }) => {
    const {
        data: {
            currentInstance: { _workflowinstance: workflowinstanceId },
        },
    } = await client.query({
        query: loadCurrentWorkflowinstanceQuery,
    });
    return workflowinstanceId;
};
